// 抛出状态模式
export const state = {
    initInfo: {
        init: false,
        line: 'A', // A线【0】B线【1】
        initTime: null,
    },

    device:{ // 设备对象模型
        state: "生产中",
        date: "2020/11/27",
        odd: "0015",
        name: "F06锅体",
        yield: "100000",
        predict: '--',
        capacity: 0,
        present: "1",
        schedule: "0%",
        reality: 0,
        upS: '0',
        loadS: '0',
        uptime: '0',
        loadtime: '0',
        up: 0,
        load: 0,
        rate: '0',
        out: 0,
        cout: 0,
        time: 0,
        second: 0,
        errorTimes: 0, // 异常次数
        errorSecond: 0, // 异常持续时间
        errorInfoList: [], // 异常信息列表
        codelist:[],
    },

    count: 0, // test
    countB: 0, // test

    driveObj: {// 设备对象
        driveA: {
            productInfo: { // 实时生产信息
                number: '', // 制令
                model: '', // 零件名称
                output: 0, // 计划产量
                doneProduct: 0, // 当前完成产量
                product: 0, // 剩余产量
                products: 0, // 产能
                doneTime: '--', // 完成时间
                progress: 0, // 进度
            },
            feeder: [// 送料机
                {title: '1#', status: '关闭', time: '--:--:--', color: 'white', line: 'A'},
            ],
            // 拉伸机
            handcar: [
                {title: '1#', status: '关闭', time: '--:--:--', color: 'white', line: 'A'},
                {title: '2#', status: '关闭', time: '--:--:--', color: 'white', line: 'A'},
            ],
            // 冲床
            punch: [
                {title: '1#', status: '关闭', time: '--:--:--', color: 'white', line: 'A'},
                {title: '2#', status: '关闭', time: '--:--:--', color: 'white', line: 'A'},
            ],
            // 机器人
            robot: [
                {title: '1#', status: '关闭', time: '--:--:--', color: 'white', line: 'A'},
                {title: '2#', status: '关闭', time: '--:--:--', color: 'white', line: 'A'},
                {title: '3#', status: '关闭', time: '--:--:--', color: 'white', line: 'A'},
            ],
        },
        driveB: {
            productInfo: { // 实时生产信息
                number: '', // 制令
                model: '', // 零件名称
                output: 0, // 计划产量
                doneProduct: 0, // 当前完成产量
                product: 0, // 剩余产量
                products: 0, // 产能
                doneTime: '--', // 完成时间
                progress: 0, // 进度
            },
            feeder: [// 送料机
                {title: '1#', status: '关闭', time: '--:--:--', color: 'white', line: 'B'},
            ],
            // 拉伸机
            handcar: [
                {title: '1#', status: '关闭', time: '--:--:--', color: 'white', line: 'B'},
                {title: '2#', status: '关闭', time: '--:--:--', color: 'white', line: 'B'},
            ],
            // 冲床
            punch: [
                {title: '1#', status: '关闭', time: '--:--:--', color: 'white', line: 'B'},
                {title: '2#', status: '关闭', time: '--:--:--', color: 'white', line: 'B'},
            ],
            // 机器人
            robot: [
                {title: '1#', status: '关闭', time: '--:--:--', color: 'white', line: 'B'},
                {title: '2#', status: '关闭', time: '--:--:--', color: 'white', line: 'B'},
                {title: '3#', status: '关闭', time: '--:--:--', color: 'white', line: 'B'},
            ],
        }
    },
    devicelist: [ // 设备列表
          {id: 845, name: '切片上料机'},
          {id: 856, name: '一拉拉伸机'},
          {id: 859, name: '二拉拉伸机'},
          {id: 890, name: '1#机器人'},
          {id: 864, name: '2#机器人'},
          {id: 833, name: '3#机器人'},
          {id: 823, name: '切边冲床'},
          {id: 842, name: '翻边冲床'},
          {id: 883, name: '卷边专机'},
          {id: 945, name: '切片上料机'},
          {id: 956, name: '一拉拉伸机'},
          {id: 959, name: '二拉拉伸机'},
          {id: 990, name: '1#机器人'},
          {id: 964, name: '2#机器人'},
          {id: 933, name: '3#机器人'},
          {id: 923, name: '切边冲床'},
          {id: 942, name: '翻边冲床'},
          {id: 983, name: '卷边专机'}
        ],
    productInfo: { // 实时生产信息
        number: '', // 制令
        model: '', // 零件名称
        output: 0, // 计划产量
        doneProduct: 0, // 当前完成产量
        product: 0, // 剩余产量
        products: 0, // 产能
        doneTime: '--', // 完成时间
        progress: 0, // 进度
    },
    productInfoB: { // 实时生产信息
        number: '', // 制令
        model: '', // 零件名称
        output: 0, // 计划产量
        doneProduct: 0, // 当前完成产量
        product: 0, // 剩余产量
        products: 0, // 产能
        doneTime: '--', // 完成时间
        progress: 0, // 进度
    },
    status: {  // 状态
        product: '生产',
        producting: '生产中',
        productWait: '待生产',
        productReady: '准备生产',
        productDone: '生产完成',
        productError: '异常停机',
        productStop: '急停',
        changeModel: '换模',
        changeingModel: '换模中',
        auto: '自动',
        hand: '手动',
        run: '运行',
        alarm: '故障',
        stop: '停机',
        wait: '待机',
        waiting: '等待',
        warning: '报警',
        normal: '正常',
        clone: '关闭',
        off: '关机',
        on: '开机',
        start: '开始',
        error: '异常',
        done: '完成',
        runStop: '停止',
        runByIn: '就绪',
        kail: 'kail'
    },
}